import './ImageGroupSelectImage.scss';
import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircle, faSearchPlus} from "@fortawesome/free-solid-svg-icons";
import {Button, Modal} from "react-bootstrap";

export interface ImageGroupSelectImageProps {
    name: string;
    showName?: string;
    src: string;
    active: boolean;
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    hideNames?: boolean;
    hoverEffect?: boolean;
}

/**
 * Component that displays an image-based option.
 * @param {boolean} active - True when the current image option is the selected one
 * @param {string} name - Tekst om weer te geven voor de optie
 * @param {string} showName - Alternatieve tekst om weer te geven in plaats van name
 * @param {string} src - De url van de afbeelding
 * @param {Function} onClick - Functie voor het verwerken van een klik op de huidige optie
 * @param {boolean} hideNames - If true the names are not displayed
 * @param {boolean} hoverEffect - If true there will be a zoom on hover
 * @constructor
 */
const ImageGroupSelectImage = ({active, name, showName, src, onClick, hideNames, hoverEffect}: ImageGroupSelectImageProps) => {
    const [showBigImage, setShowBigImage] = useState<boolean>(false);

    const showBigger = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setShowBigImage(true);
    }

    return <>
        <div className={`ImageGroupSelectImage-container ${hoverEffect ? 'hover-effect' : ''}`}>
            <div onClick={onClick} className={`ImageGroupSelectImage ${active ? 'active' : ''}`} style={{backgroundImage: `url(${src})`}}>
                {!hideNames && <span>{showName || name}</span>}
                {hoverEffect && <span onClick={showBigger} className={'showBigger'}><span className="fa-layers fa-fw" style={{width: 26, height: 26}}>
                  <FontAwesomeIcon icon={faCircle} size='2x' className={'text-main'} />
                  <FontAwesomeIcon icon={faSearchPlus} size='lg' color={'white'} style={{textAlign: 'center', verticalAlign: 'bottom'}} />
                </span></span>}
            </div>
        </div>
        {hoverEffect && <Modal show={showBigImage} onHide={() => setShowBigImage(false)} size={'lg'} backdropClassName={'modal-override'} className={'modal-override'}>
            <Modal.Header closeButton>
                <Modal.Title><FontAwesomeIcon icon={faSearchPlus} /> {showName || name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <img src={src} alt={''} width={'100%'} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowBigImage(false)}>
                    Sluiten
                </Button>
            </Modal.Footer>
        </Modal>}
    </>;
}

export default ImageGroupSelectImage;